module.exports = __webpack_public_path__ + "static/media/user-5.3b42c51b.jpg";